import { ContentType, DataObject } from "./types";

// TODO: add parse curl function

export const extractDataByType = (type: ContentType, data: DataObject) => {
  const prompts = { ...data.prompts[type] } as any;

  // If customPromptUsed is false, remove articlePrompt from the data
  if (
    type === "article" &&
    prompts &&
    "customPromptUsed" in prompts &&
    !prompts.customPromptUsed
  ) {
    delete prompts.articlePrompt;
  }
  return {
    type,
    title: data.title[type],
    ...prompts,
    ...data.commonSettings,
    ...(type === "article" ? { ...data.websiteSettings } : {}),
  };
};

export const capitalizeFirstLetter = (str: string) => {
  if (typeof str !== "string" || !str.length) {
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

interface DiscordCurlData {
  authorization?: string;
  application_id?: string;
  guild_id?: string;
  channel_id?: string;
  session_id?: string;
}

export function extractDiscordFieldsFromCurl(
  curlContent: string
): DiscordCurlData {
  const result: DiscordCurlData = {};

  // Normalize both Macos (copy as cURL) and Windows (copy as cURL (cmd))
  let normalized = curlContent
    .replace(/\^\\\^"/g, '"') // handle ^\^" => "
    .replace(/\^\^"/g, '"') // handle ^^" => "
    .replace(/\^\^/g, "") // remove leftover ^^
    .replace(/\^"/g, '"') // handle ^" => "
    .replace(/\^/g, "") // remove line breaks ^
    .replace(/\\r\\n/g, "\r\n") // normalize \r\n
    .replace(/\\n/g, "\n") // normalize \n
    .replace(/^\s+|\s+$/g, ""); // trim leading/trailing spaces

  const authMatch = normalized.match(/-H\s+["']authorization:\s*([^"']+)["']/i);
  if (authMatch) {
    result.authorization = authMatch[1].trim();
  }

  const payloadMatch = normalized.match(
    /name="payload_json"\s*\r?\n\r?\n([\s\S]+?)\r?\n[-]{2,}/
  );
  if (payloadMatch) {
    try {
      const jsonStr = payloadMatch[1].replace(/\\"/g, '"');
      const parsed = JSON.parse(jsonStr);

      result.application_id = parsed.application_id;
      result.guild_id = parsed.guild_id;
      result.channel_id = parsed.channel_id;
      result.session_id = parsed.session_id;
    } catch (err) {
      console.error("Failed to parse payload_json:", err);
    }
  }

  return result;
}

export const getRemainingDays = (expireAt: string): number => {
  // Convert "30-06-2025 13:27:04" to "2025-06-30T13:27:04"
  const [datePart, timePart] = expireAt.split(" ");
  const [day, month, year] = datePart.split("-").map(Number);

  const isoString = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}T${timePart}`;
  const expirationDate = new Date(isoString);
  const now = new Date();

  const msPerDay = 1000 * 60 * 60 * 24;
  const diffMs = expirationDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffMs / msPerDay);

  return diffDays;
};
